import { StatusBadge } from "@/components/shared/finance/StatusBadge";
import {
  createPeekContent,
  DocumentSummaryContent,
  toLineItemRows,
} from "@/components/shared/relationships/peek-content";
import { registerPeekType } from "@/components/shared/relationships/peek-registry";
import { useInvoice } from "@/features/invoices/hooks/use-invoices";
import { formatDocumentUid } from "@/lib/format";

function InvoiceContent({
  invoice,
}: {
  invoice: NonNullable<ReturnType<typeof useInvoice>["data"]>;
}) {
  return (
    <DocumentSummaryContent
      data={{
        accountId: invoice.account_id,
        accountLabel: "Customer",
        accountName: invoice.gl_accounts?.name,
        badge: <StatusBadge status={invoice.payment_status} />,
        balance: invoice.balance,
        date: invoice.date,
        lineItemsEmptyMessage: "No line items found",
        lines: toLineItemRows(invoice.lines),
        linesLabel: "Line Items",
        title: formatDocumentUid(invoice.uid, invoice.id),
        totalAmount: invoice.total_amount,
        totalPaid: invoice.total_paid,
      }}
    />
  );
}

/** Invoice quick-view content, registered on import via `src/app/peek-registrations.ts`. */
export const InvoicePeekContent = createPeekContent({
  emptyMessage: "No invoice found",
  render: (invoice) => <InvoiceContent invoice={invoice} />,
  useDetail: useInvoice,
});

registerPeekType("invoice", InvoicePeekContent);
